// EventForm.jsx - Router that delegates to CreateEventForm or EditEventForm
import React from "react";
import { useLocation, useParams } from "react-router-dom";
import CreateEventForm from "./CreateEventForm";
import EditEventForm from "./EditEventForm";

const EventForm = () => {
  const location = useLocation();
  const { eventId } = useParams();

  // Determine if this is edit mode based on URL param or navigation state
  const isEditMode = !!eventId || !!location?.state?.event;

  if (isEditMode) {
    return <EditEventForm />;
  }

  return <CreateEventForm />;
};

export default EventForm;
